import { SolutionCategoryType } from './types';

export const SOLUTION_CATEGORIES: SolutionCategoryType[] = [
  {
    id: 'industry',
    title: 'По отраслям',
  },
  {
    id: 'tasks',
    title: 'По задачам',
  },
];
